import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {ReportRequest} from '../domain/report/report-request.model';
import {Observable} from 'rxjs';
import {ReportResponse} from '../domain/report/report-response.model';

@Injectable()
export class ReportsService {

  constructor(private httpClient: HttpClient) {
  }

  report(request: ReportRequest): Observable<ReportResponse> {
    return this.httpClient.post<ReportResponse>(`${environment.serviceUrl}/ad-stats/report`, request);
  }

  getHourlyStats(adUnitId: string,  dateFrom: string, dateTo: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/ad-stats/ad-stats/hourly-stats?adUnitId=${adUnitId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }


}
